// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EaAv","toggleWrap":"styles_toggleWrap__cpxMn","content":"styles_content__3Ewy7","selectAreaCode":"styles_selectAreaCode__35_Eg"};